var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIconDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/trash"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.2031 5.8776C15.4281 5.6026 12.6365 5.46094 9.85312 5.46094C8.20312 5.46094 6.55312 5.54427 4.90312 5.71094L3.20312 5.8776",
    stroke: "#FB2047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.78906 5.03555L7.9724 3.94388C8.10573 3.15221 8.20573 2.56055 9.61406 2.56055H11.7974C13.2057 2.56055 13.3141 3.18555 13.4391 3.95221L13.6224 5.03555",
    stroke: "#FB2047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.4089 8.51172L15.8672 16.9034C15.7755 18.2117 15.7005 19.2284 13.3755 19.2284H8.02552C5.70052 19.2284 5.62552 18.2117 5.53385 16.9034L4.99219 8.51172",
    stroke: "#FB2047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.3125 14.6445H12.0875",
    stroke: "#FB2047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.61719 11.3105H12.7839",
    stroke: "#FB2047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconDel);
export default __webpack_public_path__ + "static/media/trash_icon_del.bf6b4ca52c2e4b485f1a25c9349a2a7a.svg";
export { ForwardRef as ReactComponent };